import React, { useState, useEffect } from 'react';
import Input from './Input';
import Display from './Display';

const Weather = () => {
  const [city, setCity] = useState('');
  const [weather, setWeather] = useState(null);

  // Fetch weather by city name
  const getWeatherByCity = async () => {
    if (!city.trim()) return;

    try {
      const res = await fetch(
        `https://api.weatherapi.com/v1/current.json?key=8f1693de1b9b446a84b90032251206&q=${city}`
      );
      const data = await res.json();

      if (data.error) {
        alert(data.error.message);
        setWeather(null);
      } else {
        setWeather(data);
      }
    } catch (error) {
      console.error('Error fetching weather by city:', error);
      setWeather(null);
    }
  };

  // Fetch weather
  const getWeatherByLocation = async (lat, lon) => {
    try {
      const res = await fetch(
        `https://api.weatherapi.com/v1/current.json?key=8f1693de1b9b446a84b90032251206&q=${lat},${lon}`
      );
      const data = await res.json();

      if (data.error) {
        setWeather(null);
      } else {
        setWeather(data);
        
      }
    } catch (error) {
      console.error('Error fetching weather by location:', error);
      setWeather(null);
    }
  };

  // Called on mount and on refresh
  const refreshWeather = () => {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          getWeatherByLocation(latitude, longitude);
        },
        (error) => {
          console.warn('Geolocation error:', error.message);
        }
      );
    } else {
      alert('Geolocation is not supported by this browser.');
    }
  };

  // Fetch weather on initial load using geolocation
  useEffect(() => {
    refreshWeather();
  }, []);

  return (
    <div className="Main">
      <Input city={city} setCity={setCity} fetchWeather={getWeatherByCity} />
      <Display weather={weather} />
      <button className="btn" onClick={refreshWeather}>Refresh</button>
    </div>
  );
};

export default Weather;



